module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('grid-x', {
    attrs: {
      "col": "1fr 7fr",
      "rows": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('h3', [_vm._v("Competitions")]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCompetitionKey),
      expression: "selectedCompetitionKey"
    }],
    ref: "competitionSelector",
    staticClass: "podcast-list-select",
    on: {
      "focus": function($event) {
        _vm.changeColor()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCompetitionKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a competition")]), _vm._v(" "), _vm._l((_vm.competitions), function(item, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": item['.key']
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.showNewCompetition = !_vm.showNewCompetition
      }
    }
  }, [_vm._v("New Competition")])]), _vm._v(" "), (_vm.showNewCompetition) ? _c('div', [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCompetition.name),
      expression: "newCompetition.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Competition Name"
    },
    domProps: {
      "value": (_vm.newCompetition.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCompetition, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.createCompetition
    }
  }, [_vm._v("Create Competition")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-2",
    staticStyle: {
      "padding-right": "100px"
    }
  }, [(_vm.selectedCompetitionKey) ? _c('div', {
    staticClass: "section-title"
  }, [_c('h3', [_vm._v(_vm._s(_vm.selectedCompetition.name))]), _vm._v(" "), _c('div', {
    staticClass: "tab-container"
  }, [_c('button', {
    class: {
      'active-tab': _vm.currentTab === 'post', tab: true
    },
    on: {
      "click": function($event) {
        _vm.currentTab = 'post';
      }
    }
  }, [_vm._v("Manage Post")]), _vm._v(" "), _c('button', {
    class: {
      'active-tab': _vm.currentTab === 'results', tab: true
    },
    on: {
      "click": function($event) {
        _vm.currentTab = 'results';
        _vm.getResults();
      }
    }
  }, [_vm._v("View Results")])])]) : _vm._e(), _vm._v(" "), _c('grid-x', {
    attrs: {
      "col": "2fr 0.5fr",
      "rows": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-2-1"
  }, [(_vm.selectedCompetitionKey) ? _c('div', [(_vm.currentTab == 'post') ? _c('div', [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCompetition.title),
      expression: "selectedCompetition.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.selectedCompetition.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedCompetition, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('froala-editor', {
    model: {
      value: (_vm.selectedCompetition.writtenContent),
      callback: function($$v) {
        _vm.$set(_vm.selectedCompetition, "writtenContent", $$v)
      },
      expression: "selectedCompetition.writtenContent"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "fb-editor"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentTab == 'results') ? _c('div', [(_vm.results && _vm.results.length > 0) ? _c('div', [_c('button', {
    on: {
      "click": function($event) {
        _vm.exportCsv()
      }
    }
  }, [_vm._v("Export To CSV")]), _vm._v(" "), _c('table', [_vm._l((_vm.results[0]), function(field, key, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(key))])
  }), _vm._v(" "), _vm._l((_vm.results), function(row, index) {
    return _c('tr', {
      key: index
    }, _vm._l((row), function(data, index) {
      return _c('td', {
        key: index
      }, [_vm._v(_vm._s(data))])
    }))
  })], 2)]) : _c('div', [_vm._v("No results")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "widget-buttons"
  }, [(_vm.selectedCompetition.status == 'draft' || _vm.selectedCompetition.status == 'preview') ? _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.publishCompetition();
      }
    }
  }, [_vm._v("Publish")]) : _vm._e(), _vm._v(" "), (_vm.selectedCompetition.status == 'draft') ? _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.previewCompetition();
      }
    }
  }, [_vm._v("Preview")]) : _vm._e(), _vm._v(" "), (_vm.selectedCompetition.status == 'publish' || _vm.selectedCompetition.status == 'preview') ? _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.unpublishCompetition();
      }
    }
  }, [_vm._v("Unpublish")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.saveCompData(_vm.selectedCompetition)
      }
    }
  }, [_vm._v("SAVE")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-2-2"
  }, [(_vm.currentTab == 'post' && _vm.selectedCompetitionKey) ? _c('div', [_c('h1', [_vm._v("Meta")]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Slug")]), _vm._v(" "), _c('div', {
    class: 'input-box slug-input ' + _vm.slugValid
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCompetition.slug),
      expression: "selectedCompetition.slug"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Slug"
    },
    domProps: {
      "value": (_vm.selectedCompetition.slug)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedCompetition, "slug", $event.target.value)
      }, _vm.checkSlug]
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-top": "5px",
      "padding-right": "5px"
    }
  }, [_vm._v(_vm._s(_vm.slugValid))])]), _vm._v(" "), (_vm.selectedCompetition.meta) ? _c('div', [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEO Title")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCompetition.meta.title),
      expression: "selectedCompetition.meta.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "SEO Title"
    },
    domProps: {
      "value": (_vm.selectedCompetition.meta.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedCompetition.meta, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEO Description")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCompetition.meta.description),
      expression: "selectedCompetition.meta.description"
    }],
    attrs: {
      "type": "text",
      "placeholder": "SEO Description"
    },
    domProps: {
      "value": (_vm.selectedCompetition.meta.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedCompetition.meta, "description", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('div', {
    staticClass: "tag-input-container"
  }, [_c('tag-input', {
    attrs: {
      "options": _vm.tags,
      "placeholder": "Enter tags",
      "value": _vm.selectedCompetition.tags,
      "multiple": true
    },
    on: {
      "value": _vm.updateTags
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Select Category")]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCompetition.parentCategory),
      expression: "selectedCompetition.parentCategory"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selectedCompetition, "parentCategory", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.selectCategory()
      }]
    }
  }, _vm._l((_vm.categories), function(item, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": item.name
      }
    }, [_vm._v(_vm._s(item.name))])
  }))]), _vm._v(" "), (_vm.categoryChanged) ? _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCompetition.subCategory),
      expression: "selectedCompetition.subCategory"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selectedCompetition, "subCategory", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.subCategories), function(subitem, subkey) {
    return _c('option', {
      key: subkey,
      domProps: {
        "value": subitem.name
      }
    }, [_vm._v(_vm._s(subitem.name))])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "images"
  }, [_c('div', {
    staticClass: "featured-images"
  }, [_c('h3', [_vm._v("Featured Image")]), _vm._v(" "), (_vm.selectedCompetition.image) ? _c('img', {
    attrs: {
      "src": _vm.selectedCompetition.image
    }
  }) : _vm._e(), _vm._v(" "), _c('ic-firebase-upload', {
    attrs: {
      "path": "images",
      "max-files": "1",
      "getFileName": _vm.getFileName,
      "storage": _vm.storage
    },
    on: {
      "uploaded": function($event) {
        _vm.onUploadedCompImage($event, 'image')
      },
      "upload": _vm.onUpload,
      "delete": _vm.onDelete
    },
    model: {
      value: (_vm.selectedCompetition.image),
      callback: function($$v) {
        _vm.$set(_vm.selectedCompetition, "image", $$v)
      },
      expression: "selectedCompetition.image"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "social-images"
  }, [_c('h3', [_vm._v("Social Image")]), _vm._v(" "), (_vm.selectedCompetition.socialImage) ? _c('img', {
    attrs: {
      "src": _vm.selectedCompetition.socialImage
    }
  }) : _vm._e(), _vm._v(" "), _c('ic-firebase-upload', {
    attrs: {
      "path": "images",
      "max-files": "1",
      "getFileName": _vm.getFileName,
      "storage": _vm.storage
    },
    on: {
      "uploaded": function($event) {
        _vm.onUploadedCompImage($event, 'socialImage')
      },
      "upload": _vm.onUpload,
      "delete": _vm.onDelete
    },
    model: {
      value: (_vm.selectedCompetition.socialImage),
      callback: function($$v) {
        _vm.$set(_vm.selectedCompetition, "socialImage", $$v)
      },
      expression: "selectedCompetition.socialImage"
    }
  })], 1)])]) : _vm._e()])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3553d78c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/competitions.vue
// module id = 646
// module chunks = 1